export default __webpack_public_path__ + "static/media/wild-underline-2.84db75ed.svg";